import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TableContentPopover from './TableContentPopover';

export default class TableContentCell extends Component {
    static propTypes = {
        rowIndex: PropTypes.number.isRequired,
        maxLines: PropTypes.string,
        item: PropTypes.object.isRequired,
        value: PropTypes.any,

        handlers: PropTypes.object,
        template: PropTypes.func,
        getTemplate: PropTypes.func,
        columnName: PropTypes.string,
        translation: PropTypes.string,
    };

    componentDidMount() {
        this.checkRightMoreContent(this.props.maxLines);
    }

    componentDidUpdate({ maxLines }) {
        if (maxLines !== this.props.maxLines) {
            this.checkRightMoreContent(this.props.maxLines);
        }
    }

    checkRightMoreContent = (maxLines) => {
        const overMaxLine = Number(maxLines) + 1;
        const hasHiddenLine = this.container.querySelector('.line-' + overMaxLine) !== null;

        this.container.classList.toggle('table-cell-has-popover', hasHiddenLine);
    }

    render() {
        const { columnName, maxLines, translation } = this.props;

        const hasPopover = Number(maxLines) || null;
        let content = null;

        if (columnName) {
            const { handlers, template, getTemplate, value, item, rowIndex } = this.props;
            const CellTemplate = getTemplate && getTemplate(columnName);
            const templateProps = {
                value,
                item,
                rowIndex,
                handlers
            };

            content = CellTemplate ? (
                <CellTemplate {...templateProps} />
            ) : (
                template && template(templateProps)
            );
        }

        return (
            <div className="table-cell" ref={node => this.container = node}>
                <div className="table-cell-content">
                    {content}
                </div>
                { hasPopover && <TableContentPopover content={content} translation={translation} /> }
            </div>
        );
    }
}
